<template>
  <SvgComponent
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
  >
    <path
      d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40Z"
      fill="#FAE1E3"
    />
    <path
      d="M70 40C70 56.5685 56.5685 70 40 70C23.4315 70 10 56.5685 10 40C10 23.4315 23.4315 10 40 10C56.5685 10 70 23.4315 70 40Z"
      fill="#E8828A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.1421 54.1421C50.3914 57.8929 45.3043 60 40 60C34.6957 60 29.6086 57.8929 25.8579 54.1421C22.1071 50.3914 20 45.3043 20 40C20 34.6957 22.1071 29.6086 25.8579 25.8579C29.6086 22.1071 34.6957 20 40 20C45.3043 20 50.3914 22.1071 54.1421 25.8579C57.8929 29.6086 60 34.6957 60 40C60 45.3043 57.8929 50.3914 54.1421 54.1421Z"
      fill="#8A0B16"
    />
    <path
      d="M40 60C45.3043 60 50.3914 57.8929 54.1421 54.1421C57.8929 50.3914 60 45.3043 60 40C60 34.6957 57.8929 29.6086 54.1421 25.8579C50.3914 22.1071 45.3043 20 40 20C34.6957 20 29.6086 22.1071 25.8579 25.8579C22.1071 29.6086 20 34.6957 20 40C20 45.3043 22.1071 50.3914 25.8579 54.1421C29.6086 57.8929 34.6957 60 40 60ZM33.6719 33.6719C34.4062 32.9375 35.5938 32.9375 36.3203 33.6719L39.9922 37.3438L43.6641 33.6719C44.3984 32.9375 45.5859 32.9375 46.3125 33.6719C47.0391 34.4062 47.0469 35.5938 46.3125 36.3203L42.6406 39.9922L46.3125 43.6641C47.0469 44.3984 47.0469 45.5859 46.3125 46.3125C45.5781 47.0391 44.3906 47.0469 43.6641 46.3125L39.9922 42.6406L36.3203 46.3125C35.5859 47.0469 34.3984 47.0469 33.6719 46.3125C32.9453 45.5781 32.9375 44.3906 33.6719 43.6641L37.3438 39.9922L33.6719 36.3203C32.9375 35.5859 32.9375 34.3984 33.6719 33.6719Z"
      fill="#8A0B16"
    />
    <path
      d="M33.6719 33.6719C34.4062 32.9375 35.5938 32.9375 36.3203 33.6719L39.9922 37.3438L43.6641 33.6719C44.3984 32.9375 45.5859 32.9375 46.3125 33.6719C47.0391 34.4062 47.0469 35.5938 46.3125 36.3203L42.6406 39.9922L46.3125 43.6641C47.0469 44.3984 47.0469 45.5859 46.3125 46.3125C45.5781 47.0391 44.3906 47.0469 43.6641 46.3125L39.9922 42.6406L36.3203 46.3125C35.5859 47.0469 34.3984 47.0469 33.6719 46.3125C32.9453 45.5781 32.9375 44.3906 33.6719 43.6641L37.3438 39.9922L33.6719 36.3203C32.9375 35.5859 32.9375 34.3984 33.6719 33.6719Z"
      fill="white"
    />
  </SvgComponent>
</template>

<script>
  import SvgComponent from '../ui/svg-component.vue'
  export default {
    components: {
      SvgComponent,
    },
  }
</script>
